module.exports = __webpack_public_path__ + "img/mp.ade4074a.png";